const wHeight = window.innerHeight;

window.addEventListener('scroll', expandMask);

function expandMask() {
	const masks = document.querySelectorAll('.ucg-mask');

	for (let i = 0; i < masks.length; i++) {
		const mask = masks[i];
		const rect = mask.parentElement.getBoundingClientRect();
		let top = rect.top;

		if (top < wHeight) {
			let percent = ((wHeight - top) / wHeight) * 100;
			let increase = 50 + percent;
			let decrease = (100 - percent * 1.5) / 100;
			let borderRadius = 24 * decrease;

			mask.style.opacity = 1;
			mask.style.width = increase + '%';

			if (borderRadius > 9) {
				mask.style.borderRadius = borderRadius + 'px';
			} else {
				mask.style.borderRadius = '0px';
			}
		}
	}
}
